import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach((item, index) => {
    const el = {
      ...item.user,
      key: item.user.uuid + `_${index}`,
      creator: {
        uuid: item.user.uuid,
        avatar_url: item.user.avatar_url,
        avatar_params: item.user.avatar_params,
        name: item.user.name,
        social_accounts: item.user.social_accounts
      },
      links: item.filtered_active_links,
      clicks: item.filtered_clicks,
      sales: item.filtered_gmv,
      sales_per_click: item.filtered_gmv_per_click,
      sales_per_link: item.filtered_gmv_per_link,
      conversion_rate: item.filtered_conversion_rate,
      campaigns: item.user_campaigns,
      groups: item.user_groups,
      select: { id: item.user.uuid, value: false },
      operations: {
        ...item.user,
        key: item.user.uuid + `_${index}`
      }
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getTopPerformers({ payload: { signal } }) {
  try {

    const { data } = yield call(fetch, {
      api: api.analytics.users,
      params: {
        page: 1,
        since: 'now-30d/d',
        until: 'now+1d/d',
        ordering: ['-filtered_gmv']
      },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getTopPerformersDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getTopPerformersFailed,
      endpoint: api.analytics.users.url
    });
  }
}

export const getTopPerformersSaga = takeEvery(types.GET_TOP_PERFORMERS_REQUEST, getTopPerformers);